<template lang="pug">
.results
  router-link(to="/redesign/my-history")
    .results__rating
      p.results__number {{ rating }}
      .results__arrow
        v-icon(
          size="8"
          color="redesignPrimaryDarken"
        ) $iarrow-top-right
    p.results__label Мои результаты
</template>

<script>
export default {
  name: 'ProfileTotalScore',

  data() {
    return {
      rating: 0,
    };
  },

  mounted() {
    this.getUserRating();
  },

  methods: {
    async getUserRating() {
      const { data } = await this.$api.user.getUserRating();
      this.rating = data.data.rating ? Math.round(Number(data.data.rating)) : 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.results {
  &__rating {
    display: flex;
    flex-wrap: nowrap;
    column-gap: 4px;
    justify-content: center;
    align-items: center;
  }
  &__label {
    color: #{$redesignSecondary};
    text-align: center;
    font-size: 14px;
    line-height: 1.21;
    white-space: nowrap;
  }
  &__arrow {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #{$redesignPrimaryLighten};
    border-radius: 10px;
    cursor: pointer;
  }
  &__number {
    font-weight: 500;
    font-size: 20px;
  }
}
</style>
